import styles from "./DotStep.module.scss";

interface DotStepProps {
  /** 1-based: this dot and the ones before it are filled. */
  current: number;
  total: number;
}

const DotStep = ({ current, total }: DotStepProps) => {
  const { container, dot, filled } = styles;

  return (
    <div
      className={container}
      role="img"
      aria-label={`Paso ${current} de ${total}`}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          className={`${dot} ${index < current ? filled : ""}`}
        />
      ))}
    </div>
  );
};

export default DotStep;
